// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"7195e5c9","239":"23ad9ffa","396":"12b92614","455":"b5e1b3c0","977":"c4c142ec"}[chunkId] + ".chunk.js";
};